<template>
  <div class="dress">
    <v-container>
      <v-row>
        <v-switch
          v-model="showFilters"
          label="Mostrar filtros"
          class="mt-0 mb-3"
          color="secondary"
          hide-details
        ></v-switch>
        <v-spacer></v-spacer>
        <v-btn class="mx-2" fab right color="secondary" small @click="reload">
          <v-icon> mdi-reload </v-icon>
        </v-btn>
      </v-row>
    </v-container>

    <v-card class="mb-2" v-if="showFilters">
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6" md="3" v-if="role == 'SUPERADMIN'">
            <v-select
              outlined
              :items="offices"
              item-text="name"
              item-value="id"
              label="Seleccione Oficina"
              no-data-text="No hay registros..."
              hide-details
              dense
              clearable
              v-model="filters.office"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="3" v-if="role == 'SUPERADMIN'">
            <v-select
              outlined
              :items="categories"
              item-text="name"
              item-value="id"
              label="Seleccione Categoria"
              no-data-text="No hay registros..."
              hide-details
              dense
              clearable
              v-model="filters.category"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-text-field
              label="Código"
              outlined
              hide-details
              dense
              v-model="filters.code"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3" v-if="role == 'SUPERADMIN'">
            <v-text-field
              label="Fecha desde"
              outlined
              hide-details
              dense
              type="date"
              v-model="filters.min_date"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3" v-if="role == 'SUPERADMIN'">
            <v-text-field
              label="Fecha hasta"
              outlined
              hide-details
              dense
              type="date"
              v-model="filters.max_date"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3" v-if="role == 'SUPERADMIN'">
            <v-select
              outlined
              :items="dressTypes"
              item-text="text"
              item-value="value"
              label="Tipo"
              clearable
              hide-details
              dense
              v-model="filters.type"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-btn block color="secondary" @click="searchFilters">
              Buscar
            </v-btn>
          </v-col>
          <v-col cols="12" sm="6" md="2" v-if="role === 'SUPERADMIN'">
            <v-btn block color="success" @click="exportDresses" :loading="$store.state.dresses.isLoading">
              <v-icon left>mdi-microsoft-excel</v-icon> Exportar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Busqueda"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-card-text v-if="role == 'SUPERADMIN'" class="pb-0 pt-1">
        <v-chip class="mr-2" color="primary" text-color="white" small>
          Total vestidos: {{ ($store.state.dresses.dresses.total_sold || 0) + ($store.state.dresses.dresses.total_not_sold || 0) }}
        </v-chip>
        <v-chip class="mr-2" color="error" text-color="white" small>
          Vendidos: {{ $store.state.dresses.dresses.total_sold || 0 }}
        </v-chip>
        <v-chip class="mr-2" color="orange" text-color="white" small>
          Total vendido: {{ ($store.state.dresses.dresses.total_sold_amount || 0) | currency }}
        </v-chip>
        <v-chip color="success" text-color="white" small>
          Disponibles: {{ $store.state.dresses.dresses.total_not_sold || 0 }}
        </v-chip>
      </v-card-text>
      <v-data-table
        :headers="headers"
        :items="this.$store.state.dresses.dresses.data"
        :search="search"
        hide-default-footer
        :loading="this.$store.state.categories.isLoading"
        loading-text="Cargando... Por favor espere"
        no-data-text="No hay registro"
        no-results-text="Lo sentimos no hay registro para su busqueda, intente con otro"
        :items-per-page="20"
      >
        <template v-slot:[`item.rental_value`]="item">
          {{ item.item.rental_value | formatNumber }}
        </template>
        <template v-slot:[`item.category`]="item">
          {{ item.item.category.name }}
        </template>
        <template v-slot:[`item.type`]="item">
          {{ item.item.type == "SALE" ? "Venta" : "Alquiler" }}
        </template>
        <template v-slot:[`item.employee`]="item">
          {{
            item.item.employee
              ? item.item.employee.first_name + " " + item.item.employee.last_name
              : "—"
          }}
        </template>
        <template v-slot:[`item.status`]="item">
          <v-chip
            class="ma-2"
            :color="getStatusColor(item.item.status)"
            text-color="white"
            small
          >
            {{ getStatusLan(item.item.status) }}
          </v-chip>
        </template>
        <template v-slot:[`item.loans_count`]="item">
          <v-chip class="ma-2" color="yellow" text-color="white" small>
            {{ item.item.loans_count }}
          </v-chip>
        </template>
        <template v-slot:[`item.actions`]="item">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
                @click="show(item.item.id)"
                class="px-1"
              >
                mdi-eye-outline
              </v-icon>
            </template>
            <span>VER</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="blue"
                dark
                v-bind="attrs"
                v-on="on"
                @click="showDatesLoans(item.item.id, item.item.code)"
                class="px-1"
              >
                mdi-format-list-checkbox
              </v-icon>
            </template>
            <span>VERIFICAR FECHAS</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
                @click="edit(item.item)"
                class="px-1"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span>EDITAR</span>
          </v-tooltip>
          <v-tooltip bottom v-if="role === 'SUPERADMIN'">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="red darken-2"
                dark
                v-bind="attrs"
                v-on="on"
                @click="confirmDeleteDress(item.item)"
                class="px-1"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>ELIMINAR</span>
          </v-tooltip>
          <v-tooltip bottom v-if="item.item.status !== 'SOLD'">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                :color="item.item.status == 'ACTIVE' ? 'red' : 'success'"
                dark
                v-bind="attrs"
                v-on="on"
                class="px-1"
                @click="changeStatus(item.item)"
              >
                {{
                  item.item.status == "ACTIVE"
                    ? "mdi-lock"
                    : "mdi-lock-open-variant"
                }}
              </v-icon>
            </template>
            <span>
              {{ item.item.status == "ACTIVE" ? "INACTIVAR" : "ACTIVAR" }}
            </span>
          </v-tooltip>
        </template>
      </v-data-table>
      <v-col cols="12" sm="12" md="12">
        <v-pagination
          v-model="pagination.current"
          :length="pagination.total"
          :total-visible="8"
          circle
          @input="nextPage"
        ></v-pagination>
      </v-col>
    </v-card>

    <!-- Button active dialog -->
    <v-btn class="mx-2" fab right bottom fixed color="secondary" @click="open">
      <v-icon dark> mdi-plus </v-icon>
    </v-btn>

    <!-- Create or edit dialog -->
    <v-dialog
      v-model="dialog"
      :width="currentDress.image ? '900' : '500'"
      persistent
    >
      <v-card>
        <v-card-title class="headline" v-if="isShow">
          Vestido:
          <span class="pl-2">
            <b>{{ model.code }}</b>
          </span>
        </v-card-title>

        <v-card-title class="headline" v-else>
          {{ currentDress ? "Editar" : "Crear" }} vestido
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="py-4">
          <v-row>
            <v-col cols="6" v-if="currentDress.image">
              <v-img :src="model.url" class="pa-5 mb-5"></v-img>
            </v-col>
            <v-col :cols="currentDress.image ? '6' : '12'">
              <v-form ref="form" v-model="validForm" lazy-validation>
                <v-text-field
                  v-model="model.code"
                  :rules="[rules.required]"
                  label="Codigó"
                  required
                  :readonly="isShow"
                ></v-text-field>

                <v-select
                  v-model="model.type"
                  :items="dressTypes"
                  item-text="text"
                  item-value="value"
                  :rules="[rules.required]"
                  label="Tipo"
                  required
                  :readonly="isShow"
                ></v-select>

                <v-autocomplete
                  label="Categoria"
                  :items="this.$store.state.categories.categories"
                  item-text="name"
                  item-value="id"
                  v-model="model.category_id"
                  :rules="[rules.required]"
                  :readonly="isShow"
                ></v-autocomplete>

                <v-autocomplete
                  label="Sede"
                  :items="offices"
                  item-text="name"
                  item-value="id"
                  v-model="model.office_id"
                  :rules="[rules.required]"
                  :disabled="role !== 'SUPERADMIN'"
                  :readonly="isShow"
                ></v-autocomplete>

                <v-text-field
                  v-model="model.size"
                  label="Talla"
                  required
                  :readonly="isShow"
                ></v-text-field>

                <v-text-field
                  v-model="model.color"
                  label="Color"
                  required
                  :readonly="isShow"
                ></v-text-field>

                <v-text-field
                  v-if="model.type === 'LOAN'"
                  v-model="model.rental_value"
                  :rules="[rules.required]"
                  label="Valor alquiler"
                  type="number"
                  required
                  :readonly="isShow"
                ></v-text-field>

                <v-text-field
                  v-model="model.commercial_value"
                  :rules="[rules.required]"
                  label="Valor comercial"
                  type="number"
                  required
                  :readonly="isShow"
                ></v-text-field>

                <v-autocomplete
                  v-model="model.employee_id"
                  :items="employees"
                  :item-text="employeeFullName"
                  item-value="id"
                  :rules="[rules.required]"
                  label="Asesor"
                  required
                  :readonly="isShow"
                ></v-autocomplete>

                <v-file-input
                  label="Imagen"
                  prepend-icon="mdi-file-image"
                  v-model="model.image"
                  v-if="!isShow"
                ></v-file-input>
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="py-3">
          <v-spacer></v-spacer>
          <v-btn color="error" text class="mr-4" small @click="clear">
            {{ isShow ? "Cerrar" : "Cancelar" }}
          </v-btn>
          <v-btn
            :disabled="!validForm"
            color="success"
            class="mr-4"
            small
            text
            @click="save"
            v-if="!isShow"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- change status dialog -->
    <v-dialog v-model="dialogChangeStatus" width="500" persistent>
      <v-card>
        <v-card-text class="py-4" v-if="dialogChangeStatus">
          Seguro que desea
          <b>{{ currentDress.status == "ACTIVE" ? "INACTIVAR" : "ACTIVAR" }}</b>
          este vestido?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text class="mr-4" @click="clear" small>
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            class="mr-4"
            @click="changeStatusConfirmation"
            small
            text
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete dress confirmation dialog -->
    <v-dialog v-model="dialogDelete" width="500" persistent>
      <v-card>
        <v-card-title class="headline">Eliminar vestido</v-card-title>
        <v-card-text class="py-4" v-if="dressToDelete">
          ¿Seguro que desea eliminar el vestido
          <b>{{ dressToDelete.code }}</b>? Esta acción no se puede deshacer.
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text class="mr-4" @click="dialogDelete = false" small>
            Cancelar
          </v-btn>
          <v-btn color="error" class="mr-4" @click="deleteDressConfirmation" small text>
            Eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Show dates from loans and photo studio -->
    <v-dialog width="700" persistent v-model="dialogDates">
      <v-card>
        <v-card-title class="headline">
          Vestido:
          <span class="pl-2">
            <b>{{ codeDress }}</b>
          </span>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="py-4">
          <v-data-table
            :headers="headersDates"
            :items="this.$store.state.dresses.datesLoans"
            hide-default-footer
            :loading="this.$store.state.categories.isLoadingDates"
            loading-text="Cargando... Por favor espere"
            no-data-text="No hay registro"
            :items-per-page="20"
          >
            <template v-slot:[`item.reference`]="item">
              {{ item.item.loan.reference }}
            </template>
            <template v-slot:[`item.rental_date`]="item">
              {{ item.item.loan.event_date }}
            </template>
            <template v-slot:[`item.return_date`]="item">
              {{ item.item.loan.return_date }}
            </template>
            <template v-slot:[`item.photo_studio_date`]="item">
              {{
                item.item.photo_studio_date
                  ? item.item.photo_studio_date
                  : "N/T"
              }}
            </template>
            <template v-slot:[`item.photo_studio_return_date`]="item">
              {{
                item.item.photo_studio_date_end
                  ? item.item.photo_studio_date_end
                  : "N/T"
              }}
            </template>
          </v-data-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="py-3">
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            text
            class="mr-4"
            small
            @click="dialogDates = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { SET_DRESSES, SET_CURRENT_PAGE, SET_FILTER_TEXT } from "@/store/dresses";
import { SET_OFFICES } from "@/store/offices";
import { SET_CATEGORIES } from "@/store/categories";
import { SET_EMPLOYEES } from "@/store/employee";
import { SET_ALERT } from "@/store/alert";
import { mapGetters } from "vuex";
export default {
  name: "Users",
  filters: {
    formatNumber(value) {
      return new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
      }).format(value);
    },
  },
  data: () => ({
    search: "",
    showFilters: false,
    headers: [
      {
        text: "Código",
        align: "start",
        filterable: true,
        value: "code",
      },
      {
        text: "Talla",
        align: "start",
        filterable: true,
        sortable: false,
        value: "size",
      },
      {
        text: "Color",
        align: "start",
        filterable: true,
        sortable: true,
        value: "color",
      },
      {
        text: "Valor de alquiler",
        align: "start",
        filterable: false,
        sortable: true,
        value: "rental_value",
      },
      {
        text: "Categoria",
        align: "start",
        filterable: true,
        sortable: true,
        value: "category",
      },
      {
        text: "Tipo",
        align: "start",
        filterable: true,
        sortable: true,
        value: "type",
      },
      {
        text: "Asesor",
        align: "start",
        filterable: true,
        sortable: false,
        value: "employee",
      },
      {
        text: "Alquileres",
        align: "start",
        filterable: true,
        sortable: true,
        value: "loans_count",
      },
      { text: "Estado", value: "status", filterable: false, sortable: false },
      {
        text: "Acciones",
        value: "actions",
        filterable: false,
        sortable: false,
      },
    ],
    headersDates: [
      {
        text: "Referencia",
        align: "start",
        value: "reference",
      },
      {
        text: "Fecha salida",
        align: "start",
        value: "rental_date",
      },
      {
        text: "Fecha retorno",
        align: "start",
        value: "return_date",
      },
      {
        text: "F. E. Fecha salida",
        align: "start",
        value: "photo_studio_date",
      },
      {
        text: "F. E. Fecha retorno",
        align: "start",
        value: "photo_studio_return_date",
      },
    ],
    filters: {
      office: "",
      code: "",
      category: "",
      min_date: "",
      max_date: "",
      type: "",
    },
    pagination: {
      current: 0,
      total: 0,
    },
    codeDress: "",
    dialog: false,
    dialogChangeStatus: false,
    dialogDates: false,
    validForm: true,
    currentDress: {
      image: null,
    },
    model: {
      code: "",
      size: "",
      color: "",
      rental_value: "",
      commercial_value: "",
      type: "",
      category_id: "",
      office_id: "",
      employee_id: "",
      image: null,
    },
    rules: {
      required: (value) => !!value || "Campo obligatorio.",
    },
    isShow: false,
    dialogDelete: false,
    dressToDelete: null,
    offices: [],
    categories: [],
    employees: [],
    dressTypes: [
      { value: "LOAN", text: "Alquiler" },
      { value: "SALE", text: "Venta" },
    ],
  }),
  created() {
    this.$store.dispatch("getDresses");
    this.$store.dispatch("getCategoriesAll");
    this.$store.dispatch("getOfficesAll");
    this.loadEmployees();
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === SET_DRESSES) {
        this.pagination.current = state.dresses.dresses.current_page;
        this.pagination.total = state.dresses.dresses.last_page;
      }
      if (mutation.type === SET_OFFICES) {
        this.offices = state.offices.offices;
      }
      if (mutation.type === SET_CATEGORIES) {
        this.categories = state.categories.categories;
      }
      if (mutation.type === SET_EMPLOYEES) {
        this.employees = state.employee.employees;
      }
      if (mutation.type === "SET_USER" && state.user.user) {
        this.loadEmployees();
      }
    });
  },
  watch: {
    dialog: function () {
      if (this.dialog == false) this.clear();
    },
    'model.type': function (newType) {
      if (newType === 'SALE') {
        this.model.rental_value = this.model.commercial_value;
      }
    },
    'model.commercial_value': function (newVal) {
      if (this.model.type === 'SALE') {
        this.model.rental_value = newVal;
      }
    },
  },
  computed: {
    ...mapGetters(["getStatusLan", "getStatusColor"]),
    role() {
      return this.$store.state.user.user?.role;
    },
  },
  methods: {
    reload() {
      this.filters = {
        office: "",
        code: "",
        category: "",
        min_date: "",
        max_date: "",
        type: "",
      };
      this.showFilters = false;
      this.pagination.current = 1;
      this.$store.commit(SET_CURRENT_PAGE, 1);
      this.$store.commit(SET_FILTER_TEXT, "");
      this.$store.dispatch("getDresses", "");
    },
    searchFilters() {
      this.searchFiltersText = "";

      if (this.filters.office !== "" && this.filters.office !== null) {
        this.searchFiltersText += "office=" + this.filters.office + "&";
      }

      if (this.filters.code !== "") {
        this.searchFiltersText += "code=" + this.filters.code + "&";
      }

      if (this.filters.category !== "" && this.filters.category !== null) {
        this.searchFiltersText += "category=" + this.filters.category + "&";
      }

      if (this.filters.min_date !== "" && this.filters.min_date !== null) {
        this.searchFiltersText += "min_date=" + this.filters.min_date + "&";
      }

      if (this.filters.max_date !== "" && this.filters.max_date !== null) {
        this.searchFiltersText += "max_date=" + this.filters.max_date + "&";
      }

      if (this.filters.type !== "" && this.filters.type !== null) {
        this.searchFiltersText += "type=" + this.filters.type + "&";
      }

      if (this.searchFiltersText == "") {
        this.$store.commit(SET_ALERT, {
          message: "Ingrese un valor de busqueda",
          type: "info",
        });
        return;
      }

      this.showFilters = false;
      this.pagination.current = 1;
      this.$store.commit(SET_CURRENT_PAGE, 1);
      this.$store.dispatch("getDresses", this.searchFiltersText);
    },
    exportDresses() {
      this.$store.dispatch("exportDresses", this.searchFiltersText);
    },
    nextPage() {
      this.$store.dispatch("nextPageDresses", this.pagination.current);
    },
    show(id) {
      this.$store.dispatch("getDress", id).then((dress) => {
        this.model = {
          code: dress.code,
          size: dress.size,
          color: dress.color,
          rental_value: dress.rental_value,
          commercial_value: dress.commercial_value,
          type: dress.type,
          category_id: dress.category_id,
          office_id: dress.office_id,
          employee_id: dress.employee_id,
          url: dress.url,
        };
        this.isShow = true;
        this.dialog = true;
        this.currentDress = dress;
      });
    },
    save() {
      if (!this.$refs.form.validate()) return;

      if (Object.keys(this.currentDress).length > 1) {
        this.model._method = "put";
        this.$store.dispatch("updateDress", {
          form: this.createFormData(),
          id: this.currentDress.id,
        });
      } else {
        this.$store.dispatch("createDress", this.createFormData());
      }
      this.clear();
    },
    changeStatus(user) {
      this.currentDress = user;
      this.dialogChangeStatus = true;
    },
    changeStatusConfirmation() {
      this.$store.dispatch("updateDress", {
        form: {
          status: this.currentDress.status == "ACTIVE" ? "INACTIVE" : "ACTIVE",
          _method: "put",
        },
        id: this.currentDress.id,
      });
      this.clear();
    },
    open() {
      this.dialog = true;
      this.isShow = false;
      //Prefill office with the logged user's office when creating.
      //If we're editing (edit() already set it) or showing, this won't override.
      if (!this.model.office_id) {
        this.model.office_id = this.$store.state.user.user.office_id;
      }
    },
    edit(dress) {
      this.currentDress = dress;
      this.model = {
        code: dress.code,
        size: dress.size,
        color: dress.color,
        rental_value: dress.rental_value,
        commercial_value: dress.commercial_value,
        type: dress.type,
        category_id: dress.category_id,
        office_id: dress.office_id,
        employee_id: dress.employee_id,
      };
      this.open();
    },
    clear() {
      this.dialog = false;
      this.dialogChangeStatus = false;
      if (this.model.code !== "") this.$refs.form.resetValidation();
      this.model = {
        code: "",
        size: "",
        color: "",
        rental_value: "",
        commercial_value: "",
        type: "",
        category_id: "",
        office_id: "",
        employee_id: "",
      };
      this.currentDress = {
        image: null,
      };
    },
    loadEmployees() {
      const user = this.$store.state.user.user;
      const officeId = user ? user.office_id || (user.office && user.office.id) : null;
      const filter = officeId ? "office=" + officeId : "";
      this.$store.dispatch("getEmployeesAll", filter);
    },
    employeeFullName(employee) {
      return `${employee.first_name} ${employee.last_name}`;
    },
    createFormData() {
      let formData = new FormData();
      Object.entries(this.model).forEach(([key, value]) => {
        if (value !== "" && value !== null) {
          formData.append(key, value);
        }
      });
      return formData;
    },
    confirmDeleteDress(dress) {
      this.dressToDelete = dress;
      this.dialogDelete = true;
    },
    deleteDressConfirmation() {
      this.$store.dispatch("deleteDress", this.dressToDelete.id);
      this.dialogDelete = false;
      this.dressToDelete = null;
    },
    showDatesLoans(id, code) {
      this.$store.dispatch("getDatesOfLoansAndPhotoStudio", id);
      this.codeDress = code;
      this.dialogDates = true;
    },
  },
};
</script>
